import * as React from "react"
import '../scss/project_card.scss'
import Tag from "./tag"
import Button from "./button"
import Section from "./section"
import Paragraph from "./paragraph"

const ProjectCard = ({title, description, tags, media, actions}: {
    title: string,
    description: React.ReactElement,
    tags: string[],
    media?: React.ReactElement,
    actions?: React.ReactElement
}) => {
    return <div className="ProjectCard__Container">
        <div className="ProjectCard__Top">
            <svg
                className="ProjectCard__Frame primary-fill"
                viewBox="0 0 114.10184 76.14505"
                version="1.1"
                id="svg5"
                xmlns="http://www.w3.org/2000/svg"><defs
                    id="defs2" /><g
                    id="layer1"
                    transform="translate(-36.438615,-54.260252)"><path
                    id="rect407"
                    d="m 137.38748,54.260254 -100.945167,2.55e-4 -0.0037,75.868901 114.036347,0.2759 0.0655,-63.029777 z m -96.003161,5.025491 93.754031,0.39377 10.19679,10.297399 -0.19952,55.001876 -103.685421,0.14568 z"
                    /></g></svg>
            <div
                className="ProjectCard__Video"
            >
                {media}
            </div>
        </div>
        <div className="ProjectCard__Bottom primary-background-color">
            <div className="ProjectCard__Title">
                {title}
            </div>
            <div className="ProjectCard__Tags">
                {tags.map(tag => <Tag>{tag}</Tag>)}
            </div>
            <div className="ProjectCard__Description">
                {description}
            </div>
            {
                actions && <div className="ProjectCard__Actions">
                    {actions}
                </div>
            }
           
        </div>
    </div>
}

export const ProjectWrapper = ({node}) => {
    console.log(node)
    var frontmatter = node.childMdx.frontmatter
    var body = node.childMdx.body

    var actions = <></>

    if (frontmatter.play_url) {
      actions = <>
      <Button
        reverse
        onClick={() => {
          window.open( 
            frontmatter.play_url, "_blank");
        }}
      >GIOCA</Button>
    </>
    }

    return <Section style={{marginBottom: 40}}><ProjectCard
    title={frontmatter.title}
    tags={frontmatter.tags.split(",")}
    actions={actions}
    media={
      <iframe width="100%" height="100%" src={frontmatter.youtube_embed_url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen;" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    }
    description={
      <>
        <Paragraph className="Projects__Paragraph">
          <div dangerouslySetInnerHTML={{__html: body}}></div>
        </Paragraph>
      </>
    }
  /></Section>
}


export default ProjectCard